import { SpinLoading } from "antd-mobile";

export default SpinLoading;
